import React from "react";
import { Link } from "@reach/router";
import { formatPhone } from "utils/phone";
import SlideoutEnabledContext from "pages/waitlist-update/context";
import { WaitlistUpdateRequestStatus } from "types/gql-types";
import { Button } from "components/haven-design/buttons";

const STATUS_REASON: Record<WaitlistUpdateRequestStatus, string> = {
  [WaitlistUpdateRequestStatus.ALL_BOUNCED]: "All messages bounced",
  [WaitlistUpdateRequestStatus.NO_RESPONSE]: "No response",
  [WaitlistUpdateRequestStatus.RESPONDED]: "Responded",
  [WaitlistUpdateRequestStatus.UNREACHABLE]: "No address/phone/email",
  [WaitlistUpdateRequestStatus.UNREACHABLE_LANDLINE_ONLY]: "Landline only",
};

export const NameColumnRaw: React.FC<{interestId: string, name: string | null}> =
 ({ interestId, name }) => {
   const { slideoutEnabled } = React.useContext(SlideoutEnabledContext);

   if (slideoutEnabled) {
     return (
       <Link to={`interests/${interestId}/update`}>
         {name ?? "Missing Name"}
       </Link>
     );
   }
   return (
     <a href={`/dash/manager/interest/${interestId}/activity`} rel="noreferrer" target="_blank">
       {name ?? "Missing Name"}
     </a>
   );
 };

export const PhoneColumn: React.FC<{value: string}> = ({ value }) =>
  <span>{formatPhone(value)}</span>;

export const ReasonColumn: React.FC<{status: string}> = ({ status }) => (
  <span>{STATUS_REASON[status as WaitlistUpdateRequestStatus]}</span>
);

export const ContactColumn: React.FC<{onContact:() => void }> =
 ({ onContact }) => (
   <Button color="secondary" size="S" onClick={onContact}>
     Contact
   </Button>
 );
